import { eachDayOfInterval, format, subDays } from 'date-fns'

import { ACTIVITY_DAYS } from './constants'

const DATE_KEY_FORMAT = 'yyyy-MM-dd'
const DATE_LABEL_FORMAT = 'MMM d'

interface DayBuckets {
  days: Date[]
  start: Date
  end: Date
  bucketMap: Map<string, number>
  toKey: (date: Date) => string
  toLabel: (date: Date) => string
}

export function buildDayBuckets(): DayBuckets {
  const end = new Date()
  const start = subDays(end, ACTIVITY_DAYS - 1)
  const days = eachDayOfInterval({ start, end })

  const bucketMap = new Map<string, number>()
  for (const day of days) {
    bucketMap.set(format(day, DATE_KEY_FORMAT), 0)
  }

  return {
    days,
    start,
    end,
    bucketMap,
    toKey: (date: Date) => format(date, DATE_KEY_FORMAT),
    toLabel: (date: Date) => format(date, DATE_LABEL_FORMAT),
  }
}
